import React from 'react';
import PropTypes from 'prop-types';

import {Box, ListItem, ListItemText, Typography, Link, IconButton} from 'views/components';

import {CheckCircle as CheckCircleIcon} from 'views/icons';

import {Translate} from 'views/module';

import Backend from 'utils/backend';

const SlipView = (props) => {
  const [status, setStatus] = React.useState('IN_PROGRESS');

  const item = props.item;
  const statusProgressWrap = props.statusProgressWrap;
  const weekOf = props.weekOf;

  const hourlyRate = item.hourlyRate != null ? (Math.round(item.hourlyRate * 100) / 100).toFixed(2) : null;

  const hours = item.hours;
  const confirmedHours = hours.confirmedHours != null ? Number(hours.confirmedHours.toFixed(2)) : null;
  const totalHours = hours.totalHours != null ? Number(hours.totalHours.toFixed(2)) :null;

  let confirmedCost = null;
  let totalCost = null;

  if (confirmedHours != null && hourlyRate != null) {
    confirmedCost = (confirmedHours * hourlyRate).toFixed(2);
  }
  if (totalHours != null && hourlyRate != null) {
    totalCost = (totalHours * hourlyRate).toFixed(2);
  }

  const expense = item.expenses;

  React.useEffect(() => {
    setStatus(item.status);
  }, [item]);

  const onComplete = () => {
    statusProgressWrap(async () => {
      try {
        setStatus('COMPLETE');
        await Backend.paymentSlip.markClientSlipCompete(item.clientRn, weekOf);
      } catch (e) {
        setStatus('IN_PROGRESS');
        throw e;
      }
    }, {debugString: 'CLIENT_PAYMENT_SLIP_MARK_COMPLETE_DASHBORD'});
  };

  return (
    <ListItem
      divider
      secondaryAction={
        <>
          {
            status === 'IN_PROGRESS' &&
            <IconButton
              onClick={onComplete}
              color="warning"
            >
              <CheckCircleIcon
                fontSize="medium"
              />
            </IconButton>
          }
          {
            status !== 'IN_PROGRESS' &&
            <CheckCircleIcon
              fontSize="medium"
              color="success"
              sx={{mr: 1, mt: 1}}
            />
          }
        </>
      }
    >
      <ListItemText
        primary={
          <Link
            href={`/client/${item.client.clientRn}`}
            sx={{textDecoration: 'none', color: '#1976d2', fontWeight: 500, fontSize: '1em'}}
          >
            {item.client.name.trim()}
          </Link>
        }
        secondary={
          <Box sx={{display: 'grid'}}>
            <Typography variant="caption" color="text.secondary">
              <Translate
                expression='dashboardWidgets.ClientPaymentStatus.ConfirmedHours'
                substitute={{confirmedHours}}
              />

              {
                hourlyRate &&
                <>
                  {` | `}
                  <Translate
                    expression='dashboardWidgets.ClientPaymentStatus.ConfirmedCost'
                    substitute={{confirmedCost}}
                  />
                </>
              }
            </Typography>
            <Typography variant="caption" color="text.secondary">
              <Translate
                expression='dashboardWidgets.ClientPaymentStatus.TotalHours'
                substitute={{totalHours}}
              />
              {
                hourlyRate &&
                <>
                  {` | `}
                  <Translate
                    expression='dashboardWidgets.ClientPaymentStatus.ConfirmedTotal'
                    substitute={{totalCost}}
                  />
                </>
              }
            </Typography>
            {
              Boolean(expense) &&
              <Typography variant="caption" color="text.secondary">
                <Translate
                  expression='dashboardWidgets.ClientPaymentStatus.Expenses'
                  substitute={{expense}}
                />
              </Typography>
            }
          </Box>
        }
        primaryTypographyProps={{variant: 'subtitle1'}}
        secondaryTypographyProps={{component: 'div'}}
      />
    </ListItem>
  );
};

SlipView.propTypes = {
  item: PropTypes.object.isRequired,
  weekOf: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

export default React.memo(SlipView);
